module.exports = __webpack_public_path__ + "static/media/salesforce.1518a077.png";